import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import useCurrentNavigation from '@/hooks/useCurrentNavigation';

type NavigationTitleProps = {
	className?: string;
	navigationItems?: any; // FuseNavItemType[] - optional override
	fallbackTitle?: string;
};

/**
 * NavigationTitle component displays the current page title based on the navigation item
 * that matches the current pathname. Used in page headers alongside PageBreadcrumb.
 */
function NavigationTitle(props: NavigationTitleProps) {
	const { className, navigationItems, fallbackTitle } = props;
	const currentNavigation = useCurrentNavigation(navigationItems);

	const title = currentNavigation?.title || fallbackTitle || '';

	if (!title) {
		return null;
	}

	return (
		<Typography
			className={clsx(
				'text-3xl font-bold leading-none tracking-tight text-left w-full lg:ml-0 mt-4 lg:mt-0',
				className
			)}
		>
			{title}
		</Typography>
	);
}

export default NavigationTitle;

